import { AspectRatio } from '../types.ts/video';
import { getMuxHostedThumbnailUrl, getSelfHostedThumbnailUrl } from './story';

import type {
  AssociatedVideo,
  OtherVideo,
  Story,
  StoryVideo,
} from '../types.ts/story';

export const getAssociatedVideoWithStoryVideoField = (
  video: OtherVideo,
  field: keyof StoryVideo['video'],
): AssociatedVideo | undefined => {
  const options = video.associatedVideos.filter(
    v => v.videoFilePrimary?.video?.[field],
  );
  if (!options.length) {
    return undefined;
  }
  return options.find(o => o.aspectRatio === AspectRatio.AR_16_9) || options[0];
};

export const getThumbnailTime = (
  clipJson: Record<string, any>,
): number | undefined => {
  if (clipJson.startTime == undefined) return;
  return Math.ceil(Number(clipJson.startTime) + 3);
};

export const getThumbnailUrlAndAspectRatio = (
  video: OtherVideo,
  shareableClip: AssociatedVideo | OtherVideo | undefined,
  currentStory: Story | undefined,
  aspectRatioInitial: AspectRatio = AspectRatio.AR_16_9,
): { thumbnailUrl: string | undefined; aspectRatio: AspectRatio } => {
  let aspectRatio = aspectRatioInitial;

  if (shareableClip) {
    if (video.shareableImageId) {
      return {
        thumbnailUrl: video.thumbnail?.url,
        aspectRatio,
      };
    }
    return {
      thumbnailUrl: shareableClip.thumbnail?.url,
      aspectRatio,
    };
  }

  let result =
    video.thumbnail?.url || video.videoFilePrimary?.video?.thumbnailUrl;

  if (!result) {
    const associatedVideo = getAssociatedVideoWithStoryVideoField(
      video,
      'thumbnailUrl',
    );
    if (associatedVideo) {
      result = associatedVideo?.videoFilePrimary?.video?.thumbnailUrl;
      aspectRatio = associatedVideo.aspectRatio;
    }
  }

  if (!result && currentStory?.useAws && video.clipJson) {
    result = getSelfHostedThumbnailUrl(
      currentStory?.originalVideo!,
      getThumbnailTime(video.clipJson),
    );
  } else if (!result && video.clipJson) {
    result = getMuxHostedThumbnailUrl(
      video.clipJson?.muxPlaybackId ||
        currentStory?.originalVideo.video.muxPlaybackId!,
      getThumbnailTime(video.clipJson),
    );
  }

  if (!result) {
    result = currentStory?.thumbnail?.url;
  }
  if (!result) {
    result = currentStory?.originalVideo?.video?.thumbnailUrl;
  }

  return {
    thumbnailUrl: result || '',
    aspectRatio,
  };
};
